import produce from '@reduxjs/toolkit/node_modules/immer';
import { Producer } from '../../models/producerClass';

const initialState: any[] = [
];


export const ADD_PRODUCER = 'ADD_PRODUCER';
export const SET_PRODUCERS = 'SET_PRODUCERS';
export const REMOVE_PRODUCER = 'REMOVE_PRODUCER';
export const TOGGLE_PRODUCER_LIVE = 'TOGGLE_PRODUCER_LIVE';
export const TOGGLE_PRODUCER_SPOTTED = 'TOGGLE_PRODUCER_SPOTTED';
export const TOGGLE_PRODUCER_MUTED = 'TOGGLE_PRODUCER_MUTED';
export const TOGGLE_PRODUCER_VIDEO_MUTED = 'TOGGLE_PRODUCER_VIDEO_MUTED';
export const TOGGLE_PRODUCER_MENU = 'TOGGLE_PRODUCER_MENU';
export const SWAP_PRODUCER = 'SWAP_PRODUCER';
export const SET_LAYER_PRODUCER = 'SET_LAYER_PRODUCER';
export const SET_NAME_PRODUCER = 'SET_NAME_PRODUCER';
export const SET_NAME_AND_URL_PRODUCER = 'SET_NAME_AND_URL_PRODUCER';
export const SET_PARTICIPANTINFO_IN_PRODUCER = 'SET_PARTICIPANTINFO_IN_PRODUCER';

export const ProducerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCERS: {
      return action.payload;
    }
    case ADD_PRODUCER: {
      const notEmpty = state.filter(p => p.url !== '');
      const empty = state.filter(p => p.url === '');
      return [...notEmpty, action.payload, ...empty];
    }
    case REMOVE_PRODUCER: {
      if (action.payload && action.payload.id) {
        return state.filter((p: any) => p.id !== action.payload.id);
      } else {
        return state;
      }
    }
    case TOGGLE_PRODUCER_LIVE: {
      return state.map((producer: Producer) => {
        if (producer.id === action.payload.producer.id) {
          return { ...producer, isLive: action.payload.isLive, liveRank: producer.orderRank, isSpotted: false, number: action.payload.nextRank  };
        } else {
          return producer;
        }
      });
    }
    case TOGGLE_PRODUCER_SPOTTED: {
      return state.map((producer: Producer) => {
        if (producer.id === action.payload.producer.id) {
          return { ...producer, isSpotted: action.payload.isSpotted };
        } else {
          return { ...producer, isSpotted: false };
        }
      });
    }
    case TOGGLE_PRODUCER_MUTED: {
      return state.map((producer: Producer) => {
        if (producer.id === action.payload.producer.id) {
          return { ...producer, audioMute: action.payload.audioMute };
        } else {
          return producer;
        }
      });
    }
    case TOGGLE_PRODUCER_VIDEO_MUTED: {
      return state.map((producer: Producer) => {
        if (producer.id === action.payload.producer.id) {
          return { ...producer, videoMute: action.payload.videoMute };
        } else {
          return producer;
        }
      });
    }
    case TOGGLE_PRODUCER_MENU: {
      return state.map((producer: Producer) => {
        if (action.payload.producer && producer.id === action.payload.producer.id) {
          return { ...producer, isMenuOpened: action.payload.isMenu };
        } else {
          return { ...producer, isMenuOpened: false };
        }
      });
    }
    case SWAP_PRODUCER: {
      const rank1 = action.payload.producer1.liveRank;
      const rank2 = action.payload.producer2.liveRank;
      const layer1 = action.payload.producer1.number;
      const layer2 = action.payload.producer2.number;
      return state.map((producer: Producer) => {
        if (producer.id === action.payload.producer1.id) {
          return { ...producer, liveRank: rank2, number: layer2 };
        } else if (producer.id === action.payload.producer2.id) {
          return { ...producer, liveRank: rank1, number: layer1 };
        } else {
          return producer;
        }
      });
    }
    case SET_LAYER_PRODUCER: {
      return state.map((producer: Producer) => {
        const layer = action.payload.layer.find(l => l.id === producer.id);
        if (layer) {
          return { ...producer, number: layer.number};
        } else {
          return producer;
        }
      });
    }
    case SET_NAME_PRODUCER: {
      // payload contains {...producer}
      return state.map((producer: Producer) => {
        if (action.payload.producer && producer.id === action.payload.producer.id) {
          return { ...producer, name: action.payload.name };
        } else {
          return producer;
        }
      });
    }
    case SET_NAME_AND_URL_PRODUCER: {
      // payload contains {...producer}
      return state.map((producer: Producer) => {
        if (action.payload.producer && producer.id === action.payload.producer.id) {
          return { ...producer, name: action.payload.name, url: action.payload.url, shmUrl: action.payload.shmUrl };
        } else {
          return producer;
        }
      });
    }
    case SET_PARTICIPANTINFO_IN_PRODUCER: {
      // payload contains {id, url}
      return state.map((producer: Producer) => {
        if (producer.id === action.payload.id) {
          // console.log('SET_PARTICIPANTINFO_IN_PRODUCER', action.payload);
          return { ...producer,
            url: action.payload.url,
            shmUrl: action.payload.shmUrl,
            streamIndex: action.payload.streamIndex,
            csrc: action.payload.csrc,
            name: action.payload.name || producer.name,
            participantGuid: action.payload.participantGuid,
            rosterGuid: action.payload.rosterGuid,
            audioMute: action.payload.audioMute,
            videoMute: action.payload.videoMute,
            isSpotted: action.payload.isSpotted,
            speaking: action.payload.speaking,
          };
        } else {
          return producer;
        }
      });
    }
    default:
      return state;
  }
};


